import {Divider, Tab, Tabs} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles';
import * as React from 'react';
import {useTranslation} from 'react-i18next';
import {compose} from 'redux';
import SimpleForm from './SimpleForm';
import {TFunction} from 'i18next';
import {ConfigProps} from 'redux-form';

const DEFAULT_FORM_NAME = 'simple-tabbed-form';

const styles = (): object => ({
    hiddenTab: {
        display: 'none',
        height: 'inherit',
        width: 'inherit',
    },
});

export interface TabShape {
    id: string;
    name: string;
}

interface SimpleTabbedFormProps extends ConfigProps {
    tabs: Array<TabShape>;
    renderTab: Function;
    startTab: string;
    record?: Record<string, any>;
    save?: Function;
    handleDelete?: (id: number | string) => void;
    id?: number | string;
    resource: string;
    afterDelete?: Function;
    className?: string;
    style?: object;
    toolbar?: React.ReactElement;
    paperClassName?: string;
}

interface SimpleTabbedFormInternalProps extends SimpleTabbedFormProps {
    classes: Record<string, string>;
}

interface CustomTabsProps {
    renderTab: Function;
    tabs: Array<TabShape>;
    currentTab: string;
    handleTabChange: Function;
    translate: TFunction;
    classes: Record<string, string>;
}

const CustomTabs: React.FunctionComponent<CustomTabsProps> =
    ({renderTab, tabs, currentTab, handleTabChange, translate, classes, ...props}: CustomTabsProps) => (
        <React.Fragment>
            <Tabs
                value={currentTab}
                onChange={(_e, value): void => handleTabChange(value)}
                scrollButtons='auto'
                variant='scrollable'
            >
                {tabs.map((tab, index) => (
                    <Tab
                        key={index}
                        value={tab.id}
                        label={translate(tab.name)}
                    />
                ))}
            </Tabs>
            <Divider />
            {tabs.map((tab, index) => (
                <div
                    key={`tab${index}`}
                    className={tab.id !== currentTab ? classes.hiddenTab : undefined}
                >
                    {renderTab(tab.id, props)}
                </div>
            ))}
        </React.Fragment>
    );

const SimpleTabbedFormView: React.FunctionComponent<SimpleTabbedFormInternalProps> =
    ({tabs, renderTab, startTab, classes, form, ...props}: SimpleTabbedFormInternalProps) => {
        const [currentTab, changeTab] = React.useState(startTab);
        const {t} = useTranslation();

        return (
            <SimpleForm
                {...props}
                form={form || DEFAULT_FORM_NAME}
            >
                <CustomTabs
                    translate={t}
                    classes={classes}
                    tabs={tabs}
                    renderTab={renderTab}
                    currentTab={currentTab}
                    handleTabChange={changeTab}
                />
            </SimpleForm>
        );
    };

const SimpleTabbedForm: React.FunctionComponent<SimpleTabbedFormProps> = compose(
    withStyles(styles),
)(SimpleTabbedFormView);

export default SimpleTabbedForm;
